import { render, staticRenderFns } from "./UserProfileDialog.vue?vue&type=template&id=cb3e31e8&scoped=true"
import script from "./UserProfileDialog.vue?vue&type=script&lang=js"
export * from "./UserProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./UserProfileDialog.vue?vue&type=style&index=0&id=cb3e31e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3e31e8",
  null
  
)

export default component.exports